import Storage from 'good-storage'
import Config from '../config/app.js'

export function getToken() {
    return Storage.session.get(Config.tokenKey)
}

export function setToken(token) {
    return Storage.session.set(Config.tokenKey, token)
}

export function removeToken() {
    return Storage.session.remove(Config.tokenKey)
}

export function isLogin() {
    return (getToken() || '').length >0
}

export function setPermissions(permissionsArr){
    Storage.set(Config.permissionsKey,permissionsArr)
    return permissionsArr
}

export function hasPermissions(permissionsKey){
    let permissionsArr = Storage.get(Config.permissionsKey,[])
    return permissionsArr.indexOf(permissionsKey) != -1
}

export function SessionPut(key,value) {
    return Storage.session.set(key, value)
}

export function SessionGet(key) {
    return Storage.session.get(key)
}

export function SessionClear() {
    return Storage.session.clear()
}

export function SessionRemove(key) {
    return Storage.session.remove(key)
}

export function CookiesPut(key,value) {
    return Storage.set(key, value)
}

export function CookiesGet(key) {
    return Storage.get(key)
}

export function CookiesClear() {
    return Storage.clear()
}

export function CookiesRemove(key) {
    return Storage.remove(key)
}